import React from "react";
import IBBillsGrid from "./Grid";
import Footer from "../../components/Footer";
import CancelButton from "../../components/Buttons/CancelButton";
import NextButton from "../../components/Buttons/NextButton";
import BackButton from "../../components/Buttons/BackButton";
import { redirectToIBPlanning } from "../../utils";
import { Button } from "@material-ui/core";
const IBBill = ({
  data,
  glEventHub,
  userProfile,
  showDueBills,
  updateSelectedBatches,
  goBack,
  handleNext,
  isLastStep,
}) => {
  const disableActionButton = !data;
  return (
    <>
      <IBBillsGrid
        rowData={data}
        glEventHub={glEventHub}
        userProfile={userProfile}
        showDueBills={showDueBills}
        updateSelectedBatches={updateSelectedBatches}
      />
      <Footer>
        <CancelButton onClick={redirectToIBPlanning} />
        <BackButton onClick={goBack} disabled={disableActionButton} />
        {isLastStep ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={disableActionButton}
          >
            Complete
          </Button>
        ) : (
          <NextButton onClick={handleNext} disabled={disableActionButton} />
        )}
      </Footer>
    </>
  );
};

export default IBBill;
